import { createSlice } from "@reduxjs/toolkit";
import { AccountResponseDto } from "../../shared/dtos/account/AccountResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const accountSlice = createSlice({
  name: "account",
  initialState: getInitialCrudState<AccountResponseDto>(),
  reducers: {
    ...generateCrudReducers<AccountResponseDto>(),
  },
});

export const accountActions = accountSlice.actions;
export default accountSlice.reducer;
